export default __webpack_public_path__ + "static/media/tennis-silver-cover.da12b045.png";